import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    Alert,
    Badge,
    Button,
    Card,
    CardContent,
    Checkbox,
    Chip,
    CircularProgress,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Divider,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import _ from "lodash";
import Div from "@jumbo/shared/Div";
import StateBadge from 'app/widgets/Shared/StateBadge/StateBadge';
import ManualOrderStateBadge from './ManualOrderStateBadge';
import SendToPreparationPanel from './SendToPreparationPanel';
import SendToMobileOutlinedIcon from '@mui/icons-material/SendToMobileOutlined';
import { canCloseManually } from 'app/utils/distribuidor';
import {Search, SearchIconWrapper, StyledInputBase} from "../../shared/SearchGlobal/style";
import SearchIcon from "@mui/icons-material/Search";
import CustomPagination from 'app/widgets/Shared/Pagination/CustomPagination';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import moment from 'moment';
import 'moment/locale/es';
import orderServices from 'app/services/order-services';
import fileTaskServices from 'app/services/file-task-services';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator, timelineItemClasses } from '@mui/lab';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import useJumboLayoutSidebar from '@jumbo/hooks/useJumboLayoutSidebar';
import FileUploaderModal from 'app/widgets/Shared/FileUploader/FileUploaderModal';
import { defaultSwalPreferences, hasPlugin } from 'app/utils/appHelpers';
import { getDropoffCarrierDisplay } from 'app/utils/dropoffCarriers';
import { erpDeliveryInfo } from 'app/utils/erpDeliveryDate';
import Swal from 'sweetalert2';
import SplitButton from 'app/widgets/Shared/SplitButton';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CreateOrderModal from './CreateOrderModal';
import PickupPersonModal from './PickupPersonModal';
import AgreedShippingPanel, { agreedShippingLabel } from './AgreedShippingPanel';
import ConfirmDialog from 'app/shared/widgets/ConfirmDialog';
import DirectionsCarFilledTwoToneIcon from '@mui/icons-material/DirectionsCarFilledTwoTone';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import EventAvailableTwoToneIcon from '@mui/icons-material/EventAvailableTwoTone';
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone';
import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import ShoppingBagTwoToneIcon from '@mui/icons-material/ShoppingBagTwoTone';
import StoreTwoToneIcon from '@mui/icons-material/StoreTwoTone';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import userServices from 'app/services/user-services';
import { useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import deliveryServices from 'app/services/delivery-services';
import qzPrintServices from 'app/services/qz-print-services';
import ZebraPrintDialog from './ZebraPrintDialog';
import HaulersLabelDialog from './HaulersLabelDialog';
import PackagePhotos from 'app/widgets/Images/PackagePhotos';
import PhotoCameraTwoToneIcon from '@mui/icons-material/PhotoCameraTwoTone';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import UnfoldLessOutlinedIcon from '@mui/icons-material/UnfoldLessOutlined';
import UnfoldMoreOutlinedIcon from '@mui/icons-material/UnfoldMoreOutlined';
import { DOCUMENT_TYPES, SHIPPING_KINDS, SHIPPING_KIND_KEYS } from 'app/utils/documentTypes';
import { useCompanySettings } from 'app/providers/CompanySettingsProvider/CompanySettingsProvider';
import OrderSourceBadges from 'app/shared/OrderSourceBadges';
import { ORDER_SOURCES } from 'app/utils/orderSources';


const PREPARER_MANAGER_PROFILE_NAMES = ['warehouse', 'picker', 'customer_admin', 'planner', 'supervisor'];

// Quien puede eliminar un pedido. Es la misma lista que abre `:destroy` sobre Order en el
// Ability del backend, que es quien manda: esto solo evita mostrar un boton que va a dar 403.
// Ojo con sumar 'planner' aca sin tocar el backend — tiene :manage sobre Order pero el
// Ability le cierra :destroy a proposito.
const ORDER_DELETE_PROFILE_NAMES = ['supervisor', 'customer_admin', 'superadmin'];

// Sufijo del tooltip cuando la etiqueta ya se imprimio. El contador solo aparece
// si hubo reimpresion: "1 impresion" es ruido, "3 impresiones" es justo el dato
// que hace falta cuando alguien duda de si ya la sacó.
const printedHint = (o) => {
    if (!o.label_printed_at) return '';
    const cuando = moment(o.label_printed_at).format('DD/MM HH:mm');
    const veces = o.label_printed_count > 1 ? ` · ${o.label_printed_count} impresiones` : '';
    return ` · Impresa ${cuando}${veces}`;
};

// Alto de la barra superior fija de la app (layouts/vertical-default).
const APP_HEADER_HEIGHT = 80;

// Retiro en tienda: el de ML viene en `logistic_type`, el de Shopify y Relbase tambien en `shipping_method`.
const isPickupOrder = (o) => [o.shipping_method, o.logistic_type]
    .some((v) => String(v || '').toLowerCase().trim() === 'pickup');
const sellerFullName = (seller) => seller ? `${seller.first_name || ''} ${seller.last_name || ''}`.trim() : '';

// Vendedor en la tabla: nombre e inicial del apellido ("Adriana S."), para que no parta
// en dos lineas. El nombre completo queda en el tooltip.
const sellerShortName = (seller) => {
    if (!seller) return '';
    const firstName = (seller.first_name || '').trim().split(/\s+/)[0];
    // Hay vendedores con un "." de apellido (LICITACIONES2 .): ahi no hay inicial que poner.
    const lastInitial = (seller.last_name || '').trim().charAt(0);
    return _.upperFirst(_.toLower(firstName)) + (/\p{L}/u.test(lastInitial) ? ` ${lastInitial.toUpperCase()}.` : '');
};

const OrdersList = () => {
    const {authUser} = useJumboAuth();
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
    const [listLoading, setListLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [searchQuery, setSearchQuery] = useState('')
    const [filterState, setFilterState] = useState('')
    const [filterDocumentType, setFilterDocumentType] = useState('')
    const [filterSource, setFilterSource] = useState('')
    const [showFileUploaderModal, setShowFileUploaderModal] = useState(false)
    const [importing, setImporting] = useState(false)
    const [filesToImport, setFilesToImport] = useState([])
    const [importError, setImportError] = useState('')
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newOrder, setNewOrder] = useState({customerName: '', creationDate: moment().format('YYYY-MM-DD'), products: []});
    const [orders, setOrders] = useState([])
    const [newProduct, setNewProduct] = useState({code: null, name: '', unit: null, quantity: ''});
    const [preparers, setPreparers] = useState([])
    const [highlightedElement, setHighlightedElement] = useState(null);
    // Parte cerrado: la lista de pedidos ocupa todo el ancho y el panel se abre con la flecha.
    const [showPreparers, setShowPreparers] = useState(false);
    // Pedidos desplegados en la tabla. Todos parten plegados, y se vuelven a plegar al
    // cambiar de pagina o de filtro: al volver a la pagina anterior no queda nada abierto.
    const [expandedOrderIds, setExpandedOrderIds] = useState([]);
    useEffect(() => {
        setExpandedOrderIds([]);
    }, [currentPage, filterState, filterDocumentType, filterSource, searchQuery]);
    // Alto de la cabecera fija (titulo y filtros): el panel lateral se pega justo debajo,
    // y el alto cambia cuando los filtros parten en dos lineas.
    const filtersRef = useRef(null);
    const [filtersHeight, setFiltersHeight] = useState(0);
    useEffect(() => {
        if (!filtersRef.current || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(([entry]) => setFiltersHeight(entry.target.offsetHeight));
        observer.observe(filtersRef.current);
        return () => observer.disconnect();
    }, []);
    // Lo que queda de pagina bajo la grilla (footer y padding del layout). El panel sticky no
    // puede bajar del borde de la grilla: si su alto no lo descuenta, al llegar al final de
    // la pagina el navegador lo empuja hacia arriba y el titulo queda tapado por los filtros.
    const sidePanelRef = useRef(null);
    const [pageBottomGap, setPageBottomGap] = useState(16);
    useEffect(() => {
        // Se suman el padding inferior del contenido y el alto del footer, y no la distancia a
        // la grilla: con la lista aun cargando la grilla es corta y esa distancia sale enorme.
        const measure = () => {
            const content = sidePanelRef.current?.parentElement?.parentElement;
            if (!content) return;
            const footer = document.querySelector('.CmtLayout-footer');
            const gap = (parseFloat(getComputedStyle(content).paddingBottom) || 0) + (footer?.offsetHeight || 0);
            setPageBottomGap(Math.max(16, Math.round(gap)));
        };
        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, []);
    // Sin vendedores en la pagina (Shopify, por ejemplo) el nombre no reserva lugar.
    const pageHasSellers = _.some(orders, o => sellerFullName(o.seller));
    const [printCart, setPrintCart] = useState([]);
    const [printLoading, setPrintLoading] = useState(false);
    const [zebraDialogOpen, setZebraDialogOpen] = useState(false);
    const [zebraLoading, setZebraLoading] = useState(false);
    const [bxPrintCart, setBxPrintCart] = useState([]);
    const [bxPrintLoading, setBxPrintLoading] = useState(false);
    // Etiqueta propia de Haulers: es por pedido (cada uno tiene su cantidad de
    // bultos), así que no usa carrito como las de ML/BX.
    const [haulersLabelOrder, setHaulersLabelOrder] = useState(null);
    const [pickupModalOrder, setPickupModalOrder] = useState(null);
    // Pedido de ML "acordar con el vendedor" cuyo despacho se esta definiendo.
    const [agreedPanelOrder, setAgreedPanelOrder] = useState(null);
    const [agreedSaving, setAgreedSaving] = useState(false);
    const [packagePhotosOrder, setPackagePhotosOrder] = useState(null);
    const [pickupSaving, setPickupSaving] = useState(false);
    // Pedido que se esta por eliminar, o null si el dialogo esta cerrado.
    const [orderToDelete, setOrderToDelete] = useState(null);
    const [deletingOrder, setDeletingOrder] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const currentCompanyId = authUser?.current_company?.id;
    const profileNames = Array.isArray(authUser?.profiles)
        ? authUser.profiles.map((profile) => profile?.name).filter(Boolean)
        : [];
    const currentCompanyProfileNames = Array.isArray(authUser?.profiles)
        ? authUser.profiles
            .filter((profile) => profile?.company_id === currentCompanyId)
            .map((profile) => profile?.name)
            .filter(Boolean)
        : [];
    const canAssignPreparer = profileNames.includes('superadmin') ||
        currentCompanyProfileNames.some((profileName) => PREPARER_MANAGER_PROFILE_NAMES.includes(profileName));
    const canDeleteOrder = profileNames.includes('superadmin') ||
        currentCompanyProfileNames.some((profileName) => ORDER_DELETE_PROFILE_NAMES.includes(profileName));
    // Plan Distribuidor: el estado del pedido se cambia a mano desde el rotulo.
    const canChangeOrderState = canCloseManually(authUser);
    // Plan Distribuidor: "Enviar a preparación". La seleccion es un mapa por id para que sobreviva
    // al cambio de pagina y a los filtros (la lista de `orders` es solo la pagina actual).
    const [sendToPrepOpen, setSendToPrepOpen] = useState(false);
    const [sendToPrepSelection, setSendToPrepSelection] = useState({});
    const sendToPrepSelected = Object.values(sendToPrepSelection);
    // Mismas reglas que Distribuidor::EnvioPreparacion: un pedido ya en un viaje no se reenvia.
    const sendToPrepBlockReason = (o) => {
        if (!['pending', 'invoiced', 'picked', 'prepared'].includes(o.state)) return `Un pedido ${String(o.state_name || '').toLowerCase()} no se envía`;
        const activeDelivery = (o.stats?.deliveries || []).some((d) => !['finished', 'cancelled'].includes(d.state));
        if (activeDelivery) return 'Ya está enviado o en un viaje';
        return null;
    };
    const toggleSendToPrep = (o) => {
        setSendToPrepSelection((prev) => {
            const next = { ...prev };
            if (next[o.id]) delete next[o.id]; else next[o.id] = { id: o.id, code: o.code };
            return next;
        });
    };
    const renderSendToPrepCheckbox = (o) => {
        const reason = sendToPrepBlockReason(o);
        const checked = Boolean(sendToPrepSelection[o.id]);
        return (
            <Tooltip arrow title={reason || (checked ? 'Quitar del envío' : 'Enviar a preparación')}>
                <span onClick={(e) => e.stopPropagation()}>
                    {/* La casilla deshabilitada casi no se distinguia de una libre: un candado,
                        del mismo tamaño que la casilla, deja claro que ese pedido no se puede elegir. */}
                    {reason && !checked ? (
                        <Div sx={{ p: '9px', display: 'flex', justifyContent: 'center', color: 'text.disabled', cursor: 'not-allowed' }}>
                            <LockOutlinedIcon fontSize="small" />
                        </Div>
                    ) : (
                        <Checkbox size="small" checked={checked} onChange={() => toggleSendToPrep(o)} />
                    )}
                </span>
            </Tooltip>
        );
    };
    // Abrir el panel cierra el menu lateral, como su boton: con los dos abiertos la tabla queda
    // angosta y hay que desplazarla. Al cerrarlo el menu vuelve como estaba (si ya estaba
    // cerrado, sigue cerrado).
    const sidebarWasOpenRef = useRef(false);
    // Los paneles de la derecha (Enviar a preparacion y Acordar con vendedor) cierran el menu
    // lateral para hacerse espacio; se devuelve recien cuando se cierra el ultimo de los dos.
    const hideSidebarForPanel = () => {
        if (sendToPrepOpen || agreedPanelOrder) return;
        sidebarWasOpenRef.current = Boolean(sidebarOptions?.open);
        if (sidebarWasOpenRef.current) setSidebarOptions({ open: false });
    };
    const restoreSidebar = () => {
        if (sidebarWasOpenRef.current) setSidebarOptions({ open: true });
        sidebarWasOpenRef.current = false;
    };
    const openSendToPrep = () => {
        hideSidebarForPanel();
        setSendToPrepOpen(true);
    };
    const closeSendToPrep = () => {
        if (!agreedPanelOrder) restoreSidebar();
        setSendToPrepOpen(false);
    };
    const openAgreedPanel = (order) => {
        hideSidebarForPanel();
        setAgreedPanelOrder(order);
    };
    const closeAgreedPanel = () => {
        if (!sendToPrepOpen) restoreSidebar();
        setAgreedPanelOrder(null);
    };
    const sidePanelOpen = sendToPrepOpen || Boolean(agreedPanelOrder) || (canAssignPreparer && showPreparers);
    // Titulos fijos al bajar: se muestran cuando los reales quedan bajo los filtros, y toman
    // los anchos de las columnas reales (cambian con cada pagina y con el panel lateral).
    const tableContainerRef = useRef(null);
    const stickyHeadRef = useRef(null);
    const [stickyHead, setStickyHead] = useState({ show: false, widths: [], tableWidth: 0 });
    useEffect(() => {
        const update = () => {
            const container = tableContainerRef.current;
            const thead = container?.querySelector('thead');
            if (!container || !thead) return;
            const line = APP_HEADER_HEIGHT + filtersHeight;
            const headRect = thead.getBoundingClientRect();
            const show = headRect.height > 0 && headRect.top < line && container.getBoundingClientRect().bottom > line + headRect.height;
            const widths = [...thead.querySelectorAll('th')].map((th) => th.getBoundingClientRect().width);
            const tableWidth = container.querySelector('table')?.getBoundingClientRect().width || 0;
            setStickyHead((prev) => (
                prev.show === show && prev.tableWidth === tableWidth && _.isEqual(prev.widths, widths)
                    ? prev
                    : { show, widths, tableWidth }
            ));
        };
        update();
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
        if (observer && tableContainerRef.current) observer.observe(tableContainerRef.current);
        return () => {
            window.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
            observer?.disconnect();
        };
    }, [filtersHeight, orders, sendToPrepOpen, expandedOrderIds]);
    // Al aparecer, la copia arranca en el mismo scroll horizontal que la tabla.
    useEffect(() => {
        if (stickyHead.show && stickyHeadRef.current && tableContainerRef.current) {
            stickyHeadRef.current.scrollLeft = tableContainerRef.current.scrollLeft;
        }
    }, [stickyHead.show]);
    // Con el panel abierto la tabla no cabe y scrollea de lado: la casilla queda fija a la
    // derecha para que se vea sin tener que desplazar la tabla.
    const sendToPrepCellSx = { position: 'sticky', right: 0, zIndex: 2, backgroundColor: 'background.paper', borderLeft: '1px solid', borderLeftColor: 'divider' };

    const applyManualOrderState = (updated) => {
        setOrders(prev => prev.map(o => (
            o.id === updated?.id ? { ...o, state: updated.state, state_name: updated.state_name, deletable: updated.deletable } : o
        )));
    };

    // Los tipos que la compañia dejo como "solo superadmin" no le llegan a nadie mas desde el
    // backend; ofrecerlos en el filtro seria ofrecer una lista que siempre sale vacia.
    const { companySettings } = useCompanySettings() || {};
    const hiddenDocumentTypes = profileNames.includes('superadmin') ? [] : (companySettings?.superadmin_only_document_types || []);
    // El filtro ofrece solo los tipos que la compañia tiene en algun pedido: el backend los
    // cuenta ya sin los ocultos. Mientras no llega la respuesta queda la lista completa.
    const [availableDocumentTypeKeys, setAvailableDocumentTypeKeys] = useState(null);
    // Crear un pedido puede sumar un tipo que la compañia no tenia (el primer Manual).
    const [documentTypesVersion, setDocumentTypesVersion] = useState(0);
    const visibleDocumentTypes = DOCUMENT_TYPES.filter((type) => (
        availableDocumentTypeKeys
            ? availableDocumentTypeKeys.includes(type.key)
            : !hiddenDocumentTypes.includes(type.key)
    ));
    // Flex, Full y Retiro van en el mismo filtro, solo si la compañia tiene pedidos asi.
    // Mientras no llega la respuesta no se ofrecen: casi ninguna compañia tiene Flex o Full.
    const [availableShippingKindKeys, setAvailableShippingKindKeys] = useState([]);
    const visibleShippingKinds = SHIPPING_KINDS.filter((kind) => availableShippingKindKeys.includes(kind.key));
    const availableFilterKeys = availableDocumentTypeKeys && [...availableDocumentTypeKeys, ...availableShippingKindKeys];

    useEffect(() => {
        if (!currentCompanyId) return;

        let cancelled = false;
        orderServices.getDocumentTypes()
            .then((data) => {
                if (cancelled) return;
                setAvailableDocumentTypeKeys((data?.document_types || []).map((type) => type.key));
                setAvailableShippingKindKeys((data?.shipping_kinds || []).map((kind) => kind.key));
            })
            .catch(() => {
                if (!cancelled) {
                    setAvailableDocumentTypeKeys(null);
                    setAvailableShippingKindKeys([]);
                }
            });

        return () => { cancelled = true; };
    }, [currentCompanyId, documentTypesVersion]);

    // Lo mismo para el origen: solo los que la compañia tiene. Mientras no llega, todos.
    const [availableSourceKeys, setAvailableSourceKeys] = useState(null);
    const visibleSources = ORDER_SOURCES.filter((source) => (
        !availableSourceKeys || availableSourceKeys.includes(source.key)
    ));

    useEffect(() => {
        if (!currentCompanyId) return;

        let cancelled = false;
        orderServices.getSources()
            .then((data) => {
                if (cancelled) return;
                setAvailableSourceKeys((data?.sources || []).map((source) => source.key));
            })
            .catch(() => {
                if (!cancelled) setAvailableSourceKeys(null);
            });

        return () => { cancelled = true; };
    }, [currentCompanyId, documentTypesVersion]);

    useEffect(() => {
        if (filterSource && availableSourceKeys && !availableSourceKeys.includes(filterSource)) {
            setFilterSource('');
            setCurrentPage(1);
            setListLoading(true);
        }
    }, [availableSourceKeys, filterSource]);

    // Al cambiar de compañia el tipo elegido puede no existir en la nueva: se vuelve a Todos.
    useEffect(() => {
        if (filterDocumentType && availableFilterKeys && !availableFilterKeys.includes(filterDocumentType)) {
            setFilterDocumentType('');
            setCurrentPage(1);
            setListLoading(true);
        }
    }, [availableDocumentTypeKeys, availableShippingKindKeys, filterDocumentType]);

    const handleDrop = (e, orderId) => {
        if (!canAssignPreparer) return;

        e.preventDefault();
        e.currentTarget.classList.remove('drag-over');

        const data = JSON.parse(e.dataTransfer.getData("application/json"));
        const preparerId = data.id;
        const preparerName = data.name;

        const order = orders.find(o => o.id === orderId);

        // Mismos estados que acepta el backend en Delivery#assign_preparer: una
        // entrega ya planificada en un viaje tambien puede recibir preparador.
        const hasAssignableDelivery = order.stats?.deliveries?.some(
            d => d.state === 'pending' || d.state === 'planned'
        );

        if (!hasAssignableDelivery) {
            enqueueSnackbar(
                'Solo se puede asignar preparador a pedidos con entregas pendientes o planificadas',
                { variant: 'warning' }
            );
            return;
        }

        if (!order.stats?.deliveries || order.stats.deliveries.length === 0) {
            enqueueSnackbar(
                'Este pedido no tiene entregas asociadas',
                { variant: 'warning' }
            );
            return;
        }

        const hasPreparer = Boolean(order.preparer_name);

        if (hasPreparer) {
            orderServices.replacePreparer(orderId, preparerId)
                .then(() => {
                    enqueueSnackbar(
                        'Preparador reemplazado correctamente',
                        { variant: 'success' }
                    );

                    setOrders(prev =>
                        prev.map(o =>
                            o.id === orderId
                                ? { ...o, preparer_name: preparerName }
                                : o
                        )
                    );

                    highlightPreparerField(orderId);
                })
                .catch((err) => {
                    enqueueSnackbar(
                        err?.error || 'No fue posible reemplazar el preparador',
                        { variant: 'error' }
                    );
                });

            return;
        }

        setOrders(prev =>
            prev.map(o =>
                o.id === orderId
                    ? { ...o, preparer_name: preparerName }
                    : o
            )
        );

        assignPreparerToOrder(orderId, preparerId);
    };

    const handleUnassignPreparer = async (order) => {
        if (!canAssignPreparer) return;

        if (!order.stats?.deliveries || order.stats.deliveries.length === 0) {
            enqueueSnackbar(
                'Este pedido no tiene entregas asociadas',
                { variant: 'warning' }
            );
            return;
        }

        try {
            await Promise.all(
                order.stats.deliveries.map((delivery) =>
                    deliveryServices.unassignPreparer(delivery.id)
                )
            );

            enqueueSnackbar('Preparador desasignado correctamente', {
                variant: 'success',
            });

            setOrders(prev =>
                prev.map(o =>
                    o.id === order.id
                        ? { ...o, preparer_name: null }
                        : o
                )
            );
        } catch (error) {
            enqueueSnackbar(
                'No fue posible desasignar el preparador',
                { variant: 'error' }
            );
        }
    };

    const applyPickupToState = (orderId, pickup) => {
        setOrders(prev =>
            prev.map(o => (o.id === orderId ? { ...o, pickup } : o))
        );
    };

    const handleSavePickup = (order, pickup) => {
        setPickupSaving(true);
        orderServices.updateOrder(order.id, { metadata: { pickup } })
            .then(() => {
                applyPickupToState(order.id, pickup);
                enqueueSnackbar('Persona que retira guardada', { variant: 'success' });
                setPickupModalOrder(null);
            })
            .catch(() => {
                enqueueSnackbar('No fue posible guardar la persona que retira', { variant: 'error' });
            })
            .finally(() => setPickupSaving(false));
    };

    const handleSaveAgreedShipping = (order, payload) => {
        setAgreedSaving(true);
        orderServices.setAgreedShipping(order.id, payload)
            .then((updated) => {
                // Solo lo del despacho: la respuesta no trae los includes del listado.
                const fields = _.pick(updated, [
                    'shipping_method', 'logistic_type', 'comment', 'dropoff', 'dropoff_carrier',
                    'dropoff_point', 'dropoff_name', 'meli_no_shipping', 'agreed_shipping',
                    'agreed_address', 'agreed_contact',
                ]);
                setOrders(prev => prev.map(o => (o.id === order.id ? { ...o, agreed_shipping: null, agreed_address: null, ...fields } : o)));
                enqueueSnackbar('Despacho definido', { variant: 'success' });
                closeAgreedPanel();
            })
            .catch((err) => {
                enqueueSnackbar(err?.response?.data?.error || 'No fue posible definir el despacho', { variant: 'error' });
            })
            .finally(() => setAgreedSaving(false));
    };

    const handleRemovePickup = (order) => {
        setPickupSaving(true);
        orderServices.updateOrder(order.id, { metadata: { pickup: { name: '', rut: '', plate: '', phone: '' } } })
            .then(() => {
                applyPickupToState(order.id, null);
                enqueueSnackbar('Persona que retira eliminada', { variant: 'success' });
                setPickupModalOrder(null);
            })
            .catch(() => {
                enqueueSnackbar('No fue posible eliminar la persona que retira', { variant: 'error' });
            })
            .finally(() => setPickupSaving(false));
    };

    useEffect(() => {
        if (highlightedElement) {
            highlightedElement.classList.add('just-updated-highlight');

            // Optionally remove the highlight after a delay
            const timeout = setTimeout(() => {
                highlightedElement.classList.remove('just-updated-highlight');
            }, 2000);

            return () => clearTimeout(timeout); // Cleanup timeout on unmount
        }
    }, [highlightedElement]); // Run effect when highlightedElement changes

    useEffect(() => {
        if (canAssignPreparer) {
            loadPreparers()
        } else {
            setPreparers([])
            setShowPreparers(false)
        }
    }, [canAssignPreparer])

    useEffect(() => {
        moment.locale('es-CL')
        setListLoading(true)
    }, [])

    const isSuperadmin = (user) => {
        return _.some(user?.profiles, { name: 'superadmin' });
    };

    const buildOrderParams = useCallback(() => {
        let par = [];
        if(filterState) {
            par.push(`q%5Bstate_eq%5D=${filterState}`)
        }
        if(filterDocumentType) {
            const scope = SHIPPING_KIND_KEYS.includes(filterDocumentType) ? 'with_shipping_kind' : 'with_document_type';
            par.push(`q%5B${scope}%5D=${filterDocumentType}`)
        }
        if(filterSource) {
            par.push(`q%5Bwith_source%5D=${filterSource}`)
        }
        if(searchQuery && searchQuery !== 0) {
            par.push(`q%5Bcode_or_locatable_of_Customer_type_name_or_locatable_of_Place_type_name_cont%5D=${searchQuery}`)
        }
        // if(startDate) {
        //     par.push(`q%5Bship_date_gteq%5D=${startDate}`)
        // }
        // if(endDate) {
        //     par.push(`q%5Bship_date_lteq%5D=${endDate}`)
        // }

        par.push(`page=${currentPage}`)
        par.push(`per_page=30`)
        par.push(`include=locatable.location,order_details.delivery_details.images_attachments,seller,centre`)
        par.push(`with_stats=true`)

        par = _.join(par, '&')

        return `?${par}`;
    }, [filterState, filterDocumentType, filterSource, searchQuery, currentPage]); // Add dependencies as needed

    // Numero de la ultima carga pedida. Si se cambia un filtro con otra carga en vuelo, la
    // respuesta vieja puede llegar despues y pisaria la lista filtrada; esas se descartan.
    const lastOrdersRequest = useRef(0)

    const loadOrders = useCallback(() => {
        const requestId = ++lastOrdersRequest.current
        orderServices.getOrders(buildOrderParams())
            .then(data => {
                if (requestId !== lastOrdersRequest.current) return
                setTotalPages(data.meta.total_pages)
                setCurrentPage(data.meta.current_page)
                setOrders(data.data)
                setListLoading(false)
            })
            .catch((err) => {
                if (requestId !== lastOrdersRequest.current) return
                setListLoading(false);

                if (err.response && err.response.status === 403) {
                    window.location.href = '/trips';
                }
            });
    }, [buildOrderParams]); // Add dependencies as needed

    useEffect(() => {
        if(listLoading){
            loadOrders()
        }
    }, [listLoading, loadOrders])

    const loadPreparers = () => {
        userServices.getPreparerUsers()
            .then(data => {
                if (data) {
                    setPreparers(data);
                } else {
                    console.error("Unexpected data format:", data);
                }
            })
            .catch((err) => {
                console.error("Error loading preparers:", err);
            });
    }

    // El destello verde dura 2.2s. Si en ese rato se reasigna el mismo pedido, el
    // timeout viejo apagaba el destello nuevo a media animacion, asi que se
    // guarda por pedido y se cancela antes de volver a prender.
    const preparerFlashTimeoutsRef = useRef({});

    const highlightPreparerField = (orderId) => {
        const field = document.getElementById(`preparer-field-${orderId}`);
        if (!field) return;

        clearTimeout(preparerFlashTimeoutsRef.current[orderId]);
        field.classList.remove('preparer-updated');

        // Reflow forzado: sin esto el navegador no ve el quita-pon de la clase y
        // la animacion no arranca de nuevo.
        void field.offsetWidth;
        field.classList.add('preparer-updated');

        preparerFlashTimeoutsRef.current[orderId] = setTimeout(() => {
            field.classList.remove('preparer-updated');
            delete preparerFlashTimeoutsRef.current[orderId];
        }, 2200);
    };

    const assignPreparerToOrder = (orderId, preparerId) => {
        orderServices.assignPreparer(orderId, preparerId)
            .then(() => {
                enqueueSnackbar('Preparador asignado correctamente', {
                    variant: 'success',
                });

                highlightPreparerField(orderId);
                setListLoading(true);
            })
            .catch(() => {
                enqueueSnackbar('Error al asignar el preparador', {
                    variant: 'error',
                });

                setListLoading(false);
            });
    };

    const importOrders = () => {
        setImporting(true)
        setImportError('')
        fileTaskServices.bulkImport('default_bulk_order_import', filesToImport)
            .then(data => {
                setImporting(false)
                setFilesToImport([])
                setShowFileUploaderModal(false)
                setListLoading(true)
                Swal.mixin(defaultSwalPreferences(Swal)).fire({
                    icon: 'success',
                    title: data.message,
                    background: 'success',
                });
            })
            .catch((err) => {
                setImportError(err.response?.data?.error)
                setImporting(false)
            });
    }

    const handleSearchQueryChange = (newVal) => {
        setSearchQuery(newVal)
        setCurrentPage(1)
        setListLoading(true)
    }

    const debounceSearchQueryChange = _.debounce(handleSearchQueryChange, 450)

    const handleFilterState = (newState) => {
        var finalSt = newState === filterState ? null : newState
        setFilterState(finalSt);
        setListLoading(true);
    };

    const handleFilterDocumentType = (newType) => {
        setFilterDocumentType(newType);
        setCurrentPage(1);
        setListLoading(true);
    };

    const handleFilterSource = (newSource) => {
        setFilterSource(newSource);
        setCurrentPage(1);
        setListLoading(true);
    };

    const renderFilters = () => {
        const statesList = [
            { name: 'pending',      stateName: 'Pendiente'},
            { name: 'invoiced',     stateName: 'Documentado'},
            { name: 'prepared',     stateName: 'Preparado'},
            { name: 'picked',       stateName: 'Pickeado'},
            { name: 'in_progress',  stateName: 'En progreso'},
            { name: 'finished',     stateName: 'Finalizado'},
            { name: 'cancelled',    stateName: 'Cancelado'},
            { name: 'deleted',      stateName: 'Eliminado'},
        ]
        // Dos filas: titulo y acciones arriba, los estados abajo en una linea. Asi los botones
        // no compiten con los estados por el ancho y todo queda alineado a 40px de alto.
        return (
            <Stack spacing={2} sx={{mb: 1}}>
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems={{ xs: 'stretch', md: 'center' }}
                    justifyContent="space-between"
                    spacing={2}>
                    <Typography variant="h2" sx={{ mb: 0 }}>Pedidos</Typography>

                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        spacing={1.5}
                        useFlexGap
                        flexWrap="wrap">
                        <TextField
                            select
                            size="small"
                            label="Tipo de pedido"
                            value={filterDocumentType}
                            onChange={(e) => handleFilterDocumentType(e.target.value)}
                            sx={{ width: 190, background: 'white' }}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {visibleDocumentTypes.map((type) => (
                                <MenuItem key={type.key} value={type.key}>{type.label}</MenuItem>
                            ))}
                            {visibleShippingKinds.length > 0 && visibleDocumentTypes.length > 0 && <Divider />}
                            {visibleShippingKinds.map((kind) => (
                                <MenuItem key={kind.key} value={kind.key}>{kind.label}</MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            select
                            size="small"
                            label="Origen"
                            value={filterSource}
                            onChange={(e) => handleFilterSource(e.target.value)}
                            sx={{ width: 170, background: 'white' }}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {visibleSources.map((source) => (
                                <MenuItem key={source.key} value={source.key}>{source.label}</MenuItem>
                            ))}
                        </TextField>

                        <Search sx={{ width: { xs: '100%', sm: 240 } }}>
                            <SearchIconWrapper>
                                <SearchIcon/>
                            </SearchIconWrapper>

                            <StyledInputBase
                                placeholder="Buscar"
                                inputProps={{'aria-label': 'search'}}
                                sx={{background: 'white'}}
                                onChange={(e) => {
                                    debounceSearchQueryChange(e.target.value)
                                }}
                            />
                        </Search>

                        {/* Las dos acciones verdes van juntas, al final */}
                        <Stack direction="row" alignItems="center" spacing={1}>
                            { hasPlugin(authUser?.current_company?.enabled_plugins, 'default-bulk-order-importer') &&
                                <SplitButton
                                    btnGroupProps={{
                                        color: 'success',
                                        variant: 'contained',
                                        size: 'small',
                                        sx: { height: 34, whiteSpace: 'nowrap', flexShrink: 0 },
                                    }}
                                    mainOpt={{
                                        text: "Importar",
                                        onClick: () => { setShowFileUploaderModal(true) }
                                    }}
                                    secondaryOpts={[
                                        {
                                            text: "Ver historial",
                                            onClick: () => { window.location.href = '/file_tasks' }
                                        }
                                    ]}
                                />
                            }

                            {canChangeOrderState && (
                                <Button
                                    startIcon={<SendToMobileOutlinedIcon />}
                                    variant={sendToPrepOpen ? 'contained' : 'outlined'}
                                    color="primary"
                                    size="small"
                                    sx={{ height: 34, px: 1.5, whiteSpace: 'nowrap', flexShrink: 0 }}
                                    onClick={() => (sendToPrepOpen ? closeSendToPrep() : openSendToPrep())}
                                >
                                    Enviar a preparación
                                </Button>
                            )}

                            {isSuperadmin(authUser) && (
                                <Button
                                    startIcon={<AddRoundedIcon />}
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    sx={{ height: 34, px: 1.5, whiteSpace: 'nowrap', flexShrink: 0 }}
                                    onClick={() => setShowCreateModal(true)}
                                >
                                    Crear
                                </Button>
                            )}
                        </Stack>
                    </Stack>
                </Stack>

                {/* Si no caben en una linea, bajan a la siguiente sin aplastarse */}
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap">

                    {_.map(statesList, (st) => {
                        return (
                            <StateBadge
                                key={st.name}
                                state={st.name}
                                stateName={st.stateName}
                                clickable={true}
                                variant={filterState === st.name ? 'filled' : 'outlined'}
                                onClick={() => { handleFilterState(st.name) }} />
                        )
                    })}

                    {/* En la fila de los estados y no en una propia: es alto que se le quita a la tabla. */}
                    {orders?.length > 0 && (
                        <Button
                            size="small"
                            startIcon={allOrdersExpanded ? <UnfoldLessOutlinedIcon /> : <UnfoldMoreOutlinedIcon />}
                            onClick={() => setExpandedOrderIds(allOrdersExpanded ? [] : orders.map(o => o.id))}
                            sx={{ ml: 'auto' }}
                        >
                            {allOrdersExpanded ? 'Plegar todos' : 'Desplegar todos'}
                        </Button>
                    )}
                </Stack>
            </Stack>
        )
    }

    // Eliminar un pedido. Pide confirmacion siempre: no hay "deshacer" en la pantalla, y el
    // pedido se lleva sus entregas activas al cancelarlas.
    //
    // La confirmacion va con el ConfirmDialog compartido y no con Swal: es el dialogo unico de
    // la app —el mismo de "Eliminar entrega del viaje"— y su cabecera dice explicitamente que
    // reemplaza a los Swal de confirmacion, para que los botones no cambien de pantalla en
    // pantalla. De ahi tambien que el confirmar vaya en morado: el rojo queda reservado para la
    // X de la tarjeta al pasar el mouse.
    const handleDeleteOrder = () => {
        if (!orderToDelete) return;

        // `deletable` lo calcula el backend (Order#deletable?) y por eso la X no aparece en los
        // pedidos en progreso ni finalizados. Aun asi el 422 se maneja: entre que se cargo la
        // lista y el clic, el pedido pudo salir a la calle.
        setDeletingOrder(true);
        orderServices.deleteOrder(orderToDelete.id)
            .then(() => {
                enqueueSnackbar(`Pedido Nº ${orderToDelete.code} eliminado`, { variant: 'success' });
            })
            .catch((err) => {
                const mensaje = err.response?.status === 403
                    ? 'No tienes permiso para eliminar pedidos'
                    : (err.response?.data?.error || 'No se pudo eliminar el pedido');

                enqueueSnackbar(mensaje, { variant: 'error' });
            })
            .finally(() => {
                setDeletingOrder(false);
                setOrderToDelete(null);
                // Se recarga pase lo que pase: si el 422 vino porque el pedido cambio de estado,
                // la lista en pantalla esta mostrando el estado viejo.
                setListLoading(true);
            });
    };

    const togglePrintCart = (order) => {
        // El carro de etiquetas vive en el panel lateral: si esta cerrado, agregar no se veria.
        if (!printCart.some(o => o.id === order.id)) setShowPreparers(true);
        setPrintCart(prev =>
            prev.some(o => o.id === order.id)
                ? prev.filter(o => o.id !== order.id)
                : [...prev, order]
        );
    };

    // orders.tracking_number no guarda de qué integración vino, así que se deduce por
    // quién lo pudo haber escrito. Son tres, y cada una toca un conjunto distinto:
    //   - Plugins::BluexpressTracking, solo pedidos source_system 'bsale'
    //   - Plugins::Shopify, solo los suyos
    //   - Starken::TrackingPush, solo los que tienen dropoff_carrier 'starken'
    // Mercado Libre no cuenta: escribe sobre MeliShipment, que es otra tabla.
    //
    // De ahí que un pedido Bsale con número, que no sea dropoff de Starken, lo tenga
    // por el sync de Blue Express. No se mira si el plugin está habilitado hoy: el
    // número quedó escrito igual, y apagar la integración no debería borrar el ícono
    // de los pedidos viejos.
    const isBluexpressTracking = (order) => (
        order.plugin_source === 'bsale' && order.dropoff_carrier !== 'starken'
    );

    const copyTrackingNumber = (trackingNumber) => {
        navigator.clipboard.writeText(trackingNumber)
            .then(() => enqueueSnackbar(`Número de seguimiento copiado: ${trackingNumber}`, { variant: 'success' }))
            .catch(() => enqueueSnackbar('No se pudo copiar el número de seguimiento', { variant: 'error' }));
    };

    const toggleBxPrintCart = (order) => {
        // El carro de etiquetas vive en el panel lateral: si esta cerrado, agregar no se veria.
        if (!bxPrintCart.some(o => o.id === order.id)) setShowPreparers(true);
        setBxPrintCart(prev =>
            prev.some(o => o.id === order.id)
                ? prev.filter(o => o.id !== order.id)
                : [...prev, order]
        );
    };

    // Parsea el body de error del backend independientemente de responseType
    // (blob para PDF, text para ZPL). Devuelve { error, pdf_fallback, ... } o null.
    const parseBackendError = async (err) => {
        const raw = err?.response?.data;
        if (!raw) return null;
        try {
            if (raw instanceof Blob) {
                const text = await raw.text();
                return JSON.parse(text);
            }
            if (typeof raw === 'string') return JSON.parse(raw);
            if (typeof raw === 'object') return raw;
        } catch (_) { /* not JSON */ }
        return null;
    };
    const handlePrintLabels = async () => {
        setPrintLoading(true);
        try {
            const blob = await orderServices.fetchShipmentLabels(printCart.map(o => o.id));
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url);
            if (printWindow) {
                printWindow.onload = () => { printWindow.print(); };
            }
            setPrintCart([]);
            enqueueSnackbar('Etiquetas generadas', { variant: 'success' });
        } catch (err) {
            console.error('Error fetching labels:', err);
            const parsed = await parseBackendError(err);
            enqueueSnackbar(parsed?.error || 'Error al obtener etiquetas de MercadoLibre', { variant: 'error' });
        }
        setPrintLoading(false);
    };

    const handleBluexpressPrint = async () => {
        setBxPrintLoading(true);
        try {
            const blob = await orderServices.fetchBluexpressLabels(bxPrintCart.map(o => o.id));
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url);
            if (printWindow) {
                printWindow.onload = () => { printWindow.print(); };
            }
            setBxPrintCart([]);
            enqueueSnackbar('Etiquetas BlueExpress generadas', { variant: 'success' });
        } catch (err) {
            console.error('Error fetching BX labels:', err);
            const parsed = await parseBackendError(err);
            enqueueSnackbar(parsed?.error || 'Error al obtener etiquetas de BlueExpress', { variant: 'error' });
        }
        setBxPrintLoading(false);
    };

    const handleZebraPrint = async (printer) => {
        setZebraLoading(true);
        try {
            const zpl = await orderServices.fetchShipmentLabelsZpl(printCart.map(o => o.id));
            // Si la impresora tiene nombre en el PC, se imprime por nombre: así no
            // depende de la IP, que es DHCP y cambia.
            await qzPrintServices.printZpl({
                printerName: printer.printer_name || undefined,
                host: printer.printer_name ? undefined : printer.ip,
                port: printer.port,
                zpl,
            });
            enqueueSnackbar(`Etiquetas enviadas a ${printer.name} (${printer.ip}:${printer.port})`, { variant: 'success' });
            setPrintCart([]);
            setZebraDialogOpen(false);
        } catch (err) {
            console.error('Zebra print error:', err);
            const parsed = await parseBackendError(err);

            // ML a veces solo entrega la etiqueta en PDF (pdf_fallback). En ese caso
            // cerramos el diálogo de Zebra y disparamos la impresión por PDF.
            if (parsed?.pdf_fallback) {
                setZebraDialogOpen(false);
                setZebraLoading(false);
                enqueueSnackbar('MercadoLibre no entregó esta etiqueta en ZPL. Imprimiendo por PDF...', { variant: 'warning' });
                await handlePrintLabels();
                return;
            }

            enqueueSnackbar(parsed?.error || `Error imprimiendo en Zebra: ${err.message || err}`, { variant: 'error' });
        }
        setZebraLoading(false);
    };
    // Ancho del logo de origen que va antes del numero en la tabla (ver renderOrderCodeCell).
    const ORIGIN_LOGO_WIDTH = 28;

    // En la tabla los botones del encabezado van en su propia columna (Acciones), para que
    // empiecen a la misma altura en todas las filas. Los iconos van con
    // un mismo espacio entre ellos: cada uno trae su propio margen (y los botones su
    // padding), que en la tarjeta no se nota pero en filas una debajo de otra desalinea.
    const ORDER_HEADER_TABLE_SX = {
        gap: 1,
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        '& > *, & > div:first-of-type > *': { marginLeft: '0 !important' },
        '& .MuiIconButton-root': { p: 0.25 },
        // Un bloque que en esta columna queda vacio igual sumaba el espacio entre iconos y
        // corria el resto (el logo de Mercado Libre quedaba mas a la derecha que el de Shopify).
        '& > div:empty': { display: 'none' },
    };

    // Que iconos lleva el pedido despues del numero.
    const orderHeaderSlots = (o) => {
        const sm = String(o.shipping_method || '').toLowerCase().trim();
        const plugins = authUser?.current_company?.enabled_plugins;
        const active = !['deleted', 'cancelled'].includes(o.state);
        return {
            pickup: o.plugin_source !== 'mercado-libre' && sm === 'pickup',
            meli: o.plugin_source === 'mercado-libre',
            mlPrint: !!o.meli_shipping_id && sm !== 'fulfillment' && active,
            haulersLabel: hasPlugin(plugins, 'haulers-label') && sm !== 'fulfillment' && active,
            // Tambien sin courier conocido: el nombre de la tarifa de Shopify ("ENVIO DIRECTO")
            // ya dice con quien sale el pedido. Un retiro no, que ya lleva su icono junto al numero.
            courier: !!(o.tracking_number || o.dropoff_carrier || (o.shipping_title && sm !== 'pickup')) && active,
            bxPrint: hasPlugin(plugins, 'bluexpress-tracking')
                && !!o.tracking_number
                && (!o.dropoff_carrier || o.dropoff_carrier === 'bluexpress')
                && active,
        };
    };
    // Etiqueta de pedido Retail o de la Tienda.
    const retailChip = (o) => (o.retail ? (
        <Chip label="Retail" size="small" variant="outlined" color="state_invoiced" sx={{ ml: 1, fontWeight: 600 }} />
    ) : o.source_account === 'tienda' && (
        <Chip label="Tienda" size="small" variant="outlined" color="state_invoiced" sx={{ ml: 1, fontWeight: 600 }} />
    ));

    // Pedido de ML "acordar con el vendedor": ML no trae envio ni direccion y entra como
    // retiro. El chip avisa que falta definirlo (o como quedo) y abre el panel de la derecha para hacerlo.
    const agreedShippingChip = (o) => {
        if (!o.meli_no_shipping) return null;

        const agreed = o.agreed_shipping;
        const label = agreedShippingLabel(agreed, companySettings?.available_dropoff_carriers);
        const editable = !['finished', 'deleted', 'cancelled'].includes(o.state);

        return (
            <Tooltip arrow title={agreed ? 'Despacho acordado con el comprador. Click para cambiarlo.' : 'Mercado Libre no trae envío: define cómo sale este pedido.'}>
                <Chip
                    label={label}
                    size="small"
                    variant={agreed ? 'outlined' : 'filled'}
                    color={agreed ? 'primary' : 'warning'}
                    icon={<LocalShippingTwoToneIcon fontSize="small" />}
                    onClick={editable ? (e) => { e.stopPropagation(); openAgreedPanel(o); } : undefined}
                    sx={{ ml: 1, fontWeight: 600 }}
                />
            </Tooltip>
        );
    };

    // Como sale un pedido de Mercado Libre: Full, Flex, Drop Off o retiro.
    const meliShippingIcon = (o) => {
        const sm = String(o.shipping_method || '').toLowerCase().trim();
        const lt = String(o.logistic_type || '').toLowerCase().trim();

        if (sm === 'fulfillment') {
            return (
                <img
                    src="/images/icons/meli-full.svg"
                    alt="Full"
                    style={{ height: 28, marginLeft: 6 }}
                />
            );
        }

        if (sm === 'me2' && lt === 'self_service') {
            return (
                <img
                    src="/images/icons/meli-flex.svg"
                    alt="Flex"
                    style={{ height: 30, marginLeft: 6 }}
                />
            );
        }

        if (lt === 'xd_drop_off') {
            return (
                <img
                    src="/images/icons/meli-dropoff.svg"
                    alt="Drop Off"
                    style={{ height: 20, marginLeft: 6 }}
                />
            );
        }

        if (lt === 'pickup') {
            return (
                <img
                    src="/images/icons/meli-pickup.svg"
                    alt="Pickup"
                    style={{ height: 20, marginLeft: 6 }}
                />
            );
        }

        return null;
    };

    // Si el pedido tiene algo que pintar en la columna Acciones (lo mismo que mira
    // renderOrderHeader con part 'actions').
    const tieneAcciones = (o) => {
        const slots = orderHeaderSlots(o);
        return slots.mlPrint || slots.haulersLabel || slots.courier || slots.bxPrint || !!o.tracking_number;
    };

    // Con `part: 'actions'` pinta solo los botones, para la columna Acciones de la tabla.
    const renderOrderHeader = (o, { inTable = false, part = null } = {}) => {
        const slots = orderHeaderSlots(o);
        const show = (p) => !part || part === p;
        return (
        <Div sx={{
            display: 'flex', alignItems: 'center', mb: 1,
            ...(inTable && ORDER_HEADER_TABLE_SX),
            // Los botones llevan 2px de padding: los iconos sueltos (retiro, courier sin
            // seguimiento) se igualan para que el primero de la fila empiece donde todos.
            ...(part === 'actions' && { '& > img, & > span': { px: '2px' } }),
        }}>
            <Div
                sx={{
                    minWidth: inTable ? 0 : 190,
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 0,
                    ...(inTable && { gap: 1 }),
                }}
            >
                {/* La fila de la tabla pinta el numero y el origen en renderOrderCodeCell. */}
                {!part && <Typography variant="h4" sx={{ mb: 0 }}>Nº {o.code}</Typography>}

                {!part && <OrderSourceBadges order={o} />}

                {!part && retailChip(o)}

                {!part && agreedShippingChip(o)}

            </Div>

            {/* El retiro se avisa para cualquier origen, no solo meli: un pedido
                que el cliente pasa a buscar no debe programarse en un viaje.
                Se excluye meli porque su propio bloque ya pinta este ícono. */}
            {!part && (slots.pickup && (
                <img
                    src="/images/icons/meli-pickup.svg"
                    alt="Retiro"
                    style={{ height: 20, marginLeft: 8 }}
                />
            ))}

            {!part && (slots.meli && (
                <>
                    <img
                        src="/images/icons/mercado-libre-color.svg"
                        alt="Mercado Libre"
                        style={{ width: 20, height: 28, marginLeft: 8 }}
                    />
                    {meliShippingIcon(o)}
                </>
            ))}

            {show('actions') && (slots.mlPrint && (
                <Tooltip title={(printCart.some(x => x.id === o.id) ? "Quitar de impresión" : "Agregar a impresión") + printedHint(o)} arrow>
                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); togglePrintCart(o); }}
                        sx={{ ml: 1 }}
                    >
                        <Badge
                            color="success"
                            variant="dot"
                            overlap="circular"
                            invisible={!o.label_printed_at}
                        >
                            <PrintOutlinedIcon
                                fontSize="small"
                                color={printCart.some(x => x.id === o.id) ? "primary" : "action"}
                            />
                        </Badge>
                    </IconButton>
                </Tooltip>
            ))}

            {/* Un Full lo etiqueta y despacha Mercado Libre desde su bodega:
                la etiqueta propia no tiene donde ir. */}
            {show('actions') && (slots.haulersLabel && (
                <Tooltip title="Imprimir etiqueta Haulers" arrow>
                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); setHaulersLabelOrder(o); }}
                        sx={{ ml: 1 }}
                    >
                        <QrCode2Icon fontSize="small" color="action" />
                    </IconButton>
                </Tooltip>
            ))}

            {/* Seguimiento del courier: el número lo deja el sync del courier o el
                correo de la agencia. Si sabemos armar la URL el ícono es un link a la
                página del courier; si no, copia el número. */}
            {show('actions') && (slots.courier && (() => {
                const carrier = getDropoffCarrierDisplay(o.dropoff_carrier, companySettings?.available_dropoff_carriers);
                const icono = carrier?.iconPath ? (
                    <img src={carrier.iconPath} alt={carrier.label} style={{ height: 18 }} />
                ) : (
                    <LocalShippingTwoToneIcon fontSize="small" color="action" />
                );

                // Sin número de seguimiento todavía: el logo es solo un indicador de
                // por qué courier saldrá el pedido (lo eligió el comprador en el
                // checkout). No es clickeable porque no hay nada que rastrear aún.
                if (!o.tracking_number) {
                    return (
                        <Tooltip
                            arrow
                            title={[
                                carrier ? `Se enviará por ${carrier.label}` : 'Envío',
                                o.shipping_title && `Tarifa: ${o.shipping_title}`,
                            ].filter(Boolean).join(' · ')}
                        >
                            <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8, opacity: 0.85 }}>
                                {icono}
                            </span>
                        </Tooltip>
                    );
                }

                const titulo = ['Seguimiento', carrier?.label, o.tracking_number]
                    .filter(Boolean).join(' ');

                return (
                    <Tooltip title={o.tracking_url ? titulo : `${titulo} (copiar)`} arrow>
                        <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            component={o.tracking_url ? 'a' : 'button'}
                            href={o.tracking_url || undefined}
                            target={o.tracking_url ? '_blank' : undefined}
                            rel={o.tracking_url ? 'noopener noreferrer' : undefined}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (o.tracking_url) return;
                                navigator.clipboard?.writeText(o.tracking_number);
                                enqueueSnackbar(`Seguimiento ${o.tracking_number} copiado`, { variant: 'info' });
                            }}
                        >
                            {icono}
                        </IconButton>
                    </Tooltip>
                );
            })())}

            {/* La etiqueta de BlueExpress es de BX: sin el plugin, el backend rechaza
                la impresión igual, y el ícono aparecía en cualquier pedido con
                tracking (los de Starken, por ejemplo). */}
            {show('actions') && (slots.bxPrint && (
                <Tooltip title={(bxPrintCart.some(x => x.id === o.id) ? "Quitar etiqueta BX" : "Agregar etiqueta BlueExpress") + printedHint(o)} arrow>
                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); toggleBxPrintCart(o); }}
                        sx={{ ml: 1 }}
                    >
                        <Badge
                            color="success"
                            variant="dot"
                            overlap="circular"
                            invisible={!o.label_printed_at}
                        >
                            <PrintOutlinedIcon
                                fontSize="small"
                                sx={{ color: bxPrintCart.some(x => x.id === o.id) ? '#0052cc' : undefined }}
                                color={bxPrintCart.some(x => x.id === o.id) ? "inherit" : "action"}
                            />
                        </Badge>
                    </IconButton>
                </Tooltip>
            ))}

            {/* El número lo escriben tanto el sync de Blue Express como el de
                Shopify, así que el rótulo va genérico: poner "Blue Express" acá
                etiquetaría mal a los pedidos que vienen de Shopify. Se muestra
                aunque el pedido esté anulado, que es justo cuando soporte
                necesita rastrear el envío. */}
            {show('actions') && o.tracking_number && (
                <Tooltip
                    arrow
                    title={isBluexpressTracking(o)
                        ? 'Número de seguimiento de Blue Express. Clic para copiarlo.'
                        : 'Número de seguimiento. Clic para copiarlo.'}>
                    <Chip
                        size="small"
                        variant="outlined"
                        label={o.tracking_number}
                        icon={isBluexpressTracking(o) ? (
                            <img
                                src="/images/icons/blueexpress.svg"
                                alt="Blue Express"
                                style={{ height: 16, width: 16, borderRadius: '50%', objectFit: 'cover' }}
                            />
                        ) : undefined}
                        onClick={(e) => { e.stopPropagation(); copyTrackingNumber(o.tracking_number); }}
                        sx={{ ml: 1, cursor: 'pointer', fontFamily: 'monospace' }}
                    />
                </Tooltip>
            )}
        </Div>
        );
    };

    // Pedido desplegado: la tarjeta de siempre, en lugar de la fila (no debajo de ella,
    // para no repetir los datos que la fila ya muestra).
    // Un clic en la tarjeta la pliega, igual que un clic en la fila la despliega. Salvo en lo
    // que tiene su propio clic, si se esta seleccionando texto para copiarlo, y en lo que se
    // abre desde la tarjeta: dialogos y menus van en un portal fuera de ella, pero el clic
    // igual llega aca por el arbol de React.
    const plegarConClic = (e, o) => {
        if (!e.currentTarget.contains(e.target)) return;
        if (e.target.closest('button, a, input, textarea, select, label, [role="button"], [role="checkbox"]')) return;
        if (window.getSelection()?.toString()) return;
        toggleOrderExpanded(o.id);
    };

    const renderOrderCard = (o) => (
        <Card
            className='order-card'
            sx={{ position: 'relative', cursor: 'pointer' }}
            onClick={(e) => plegarConClic(e, o)}
            onDragOver={canAssignPreparer ? handleDragOver : undefined}
            onDragLeave={canAssignPreparer ? handleDragLeave : undefined}
            onDrop={canAssignPreparer ? (e) => handleDrop(e, o.id) : undefined}
        >
            <CardContent sx={{ p: 1 }}>
                {/* Eliminar el pedido. Va fuera del Grid y posicionada sobre la
                    esquina: la fila de arriba a la derecha ya la ocupan los datos
                    del pedido, y una columna propia para un solo icono le comeria
                    ancho a todas las cards, tengan o no el boton.

                    `o.deletable` lo calcula el backend (Order#deletable?): es falso
                    en los pedidos en progreso, finalizados y ya eliminados. */}
                {canDeleteOrder && o.deletable && (
                    <Tooltip title="Eliminar pedido" arrow>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); setOrderToDelete(o); }}
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                p: 0.25,
                                zIndex: 1,
                                color: 'text.disabled',
                                '&:hover': { color: 'error.main' },
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3} py={0} sx={{ minWidth: 0 }}>
                        <Div sx={{ display: 'flex', alignItems: 'flex-start' }}>
                            <Tooltip title="Plegar" arrow>
                                <IconButton size="small" onClick={() => toggleOrderExpanded(o.id)} sx={{ mr: 0.5 }}>
                                    <KeyboardArrowUpIcon />
                                </IconButton>
                            </Tooltip>
                            {renderOrderHeader(o)}
                        </Div>

                        <Tooltip title="Fecha de despacho" arrow placement='left'>
                            <Div sx={{display: 'flex', alignItems: 'center', mb: 0}}>
                                <CalendarMonthTwoToneIcon fontSize="small" color={"primary"} />
                                <Typography variant="body2" color={"text.secondary"} ml={1}>{moment(o.ship_date).utc().format('DD MMM')}</Typography>
                            </Div>
                        </Tooltip>
                        {erpDeliveryInfo(o) && (
                            <Tooltip title={erpDeliveryInfo(o).titulo} arrow placement='left'>
                                <Div sx={{display: 'flex', alignItems: 'center', mb: 0}}>
                                    <EventAvailableTwoToneIcon fontSize="small" color={"primary"} />
                                    <Typography variant="body2" color={erpDeliveryInfo(o).color} ml={1}>
                                        {erpDeliveryInfo(o).texto}
                                    </Typography>
                                </Div>
                            </Tooltip>
                        )}
                        <Tooltip title="Centro de distribución" arrow placement='left'>
                            <Div sx={{display: 'flex', alignItems: 'center', mb: 0}}>
                                <StoreTwoToneIcon fontSize="small" color={"primary"} />
                                <Typography variant="body2" color={"text.secondary"} ml={1}>{o.centre?.code}{o.centre?.name && ` - ${o.centre?.name}`}</Typography>
                            </Div>
                        </Tooltip>
                        <Tooltip title="Cliente" arrow placement='left'>
                            <Div sx={{display: 'flex', alignItems: 'center', mb: 0}}>
                                <PersonOutlineTwoToneIcon fontSize="small" color={"primary"} />
                                <Typography variant="body2" color={"text.secondary"} ml={1}>{o.locatable?.name}</Typography>
                            </Div>
                        </Tooltip>
                        {o.preparer_name && (
                            <Div
                                id={`preparer-field-${o.id}`}
                                id={`preparer-field-${o.id}`}
                                className="preparer-field"
                                sx={{ display: 'flex', alignItems: 'center', mb: 0 }}
                            >
                                <AssignmentIndTwoToneIcon fontSize="small" color="primary" />
                                <Typography variant="body2" color="text.secondary" ml={1}>
                                    {o.preparer_name}
                                </Typography>

                                {canAssignPreparer && (
                                    <Tooltip title="Quitar preparador">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleUnassignPreparer(o)}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Div>
                        )}
                        {o.plugin_source === 'mercado-libre' && o.source_account && (
                            <Tooltip title="Cuenta de Mercado Libre" arrow placement="left">
                                <Div sx={{ display: 'flex', alignItems: 'center' }}>
                                    <EmailTwoToneIcon fontSize="small" color="primary" />
                                    <Typography variant="body2" color="text.secondary" ml={1}>
                                        {o.source_account}
                                    </Typography>
                                </Div>
                            </Tooltip>
                        )}
                        { o.seller && (
                            <Tooltip title="Vendedor" arrow placement='left'>
                                <Div sx={{display: 'flex', alignItems: 'center', mb: 0}}>
                                    <ShoppingBagTwoToneIcon fontSize="small" color={"primary"} />
                                    <Typography variant="body2" color={"text.secondary"} ml={1}>{o.seller?.first_name} {o.seller?.last_name}</Typography>
                                </Div>
                            </Tooltip>
                        )}
                        {o.pickup?.name && (
                            <Tooltip title="Retira" arrow placement='left'>
                                <Div
                                    role="button"
                                    sx={{ display: 'flex', alignItems: 'center', mb: 0, cursor: o.state !== 'finished' ? 'pointer' : 'default' }}
                                    onClick={() => o.state !== 'finished' && setPickupModalOrder(o)}
                                >
                                    <DirectionsCarFilledTwoToneIcon fontSize="small" color={"primary"} />
                                    <Typography variant="body2" color={"text.secondary"} ml={1}>{o.pickup.name}</Typography>
                                </Div>
                            </Tooltip>
                        )}
                        <Div sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                            {/* En un pedido eliminado el rotulo del estado dice quien lo elimino y
                                cuando: es la unica pantalla donde ese dato hace falta, y ponerlo en
                                el tooltip del estado evita sumarle una linea a cada tarjeta. */}
                            {canChangeOrderState && o.state !== 'deleted' ? (
                                <ManualOrderStateBadge order={o} onChanged={applyManualOrderState} />
                            ) : (
                            <Tooltip
                                arrow
                                placement='left'
                                title={o.state === 'deleted'
                                    ? `Eliminado por ${o.deleted_by_name || 'un usuario que ya no existe'}${o.deleted_at ? ` el ${moment(o.deleted_at).format('LLL')}` : ''}`
                                    : 'Estado del pedido'}>
                                <Div>
                                    <StateBadge state={o.state} stateName={o.state_name} withIcon={true}/>
                                </Div>
                            </Tooltip>
                            )}
                            {/* Solo en retiros: es el mismo criterio que el filtro "Retiro en tienda"
                                (`Order::SHIPPING_KIND_SQL`). Si ya tiene a alguien anotado se deja,
                                para poder corregirlo aunque el pedido haya dejado de ser retiro. */}
                            {o.state !== 'finished' && (isPickupOrder(o) || o.pickup?.name) && (
                                <Tooltip title="Retira" arrow>
                                    <IconButton
                                        size="small"
                                        onClick={() => setPickupModalOrder(o)}
                                        sx={{ ml: 0.5, p: 0.25 }}
                                    >
                                        <DirectionsCarFilledTwoToneIcon
                                            fontSize="small"
                                            color={o.pickup?.name ? 'success' : 'action'}
                                        />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {o.package_photos_count > 0 && (
                                <Tooltip title="Fotos de bultos" arrow>
                                    <IconButton
                                        size="small"
                                        onClick={() => setPackagePhotosOrder(o)}
                                        sx={{ ml: 0.5, p: 0.25 }}
                                    >
                                        <Badge badgeContent={o.package_photos_count} color="primary" sx={{ '& .MuiBadge-badge': { fontSize: 10, height: 16, minWidth: 16 } }}>
                                            <PhotoCameraTwoToneIcon fontSize="small" color="primary" />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Div>
                        <Div sx={{display: 'flex', alignItems: 'center'}}>
                            <Div sx={{width: '100%', mr: 1}}>
                                {/* <LinearProgress variant="determinate" color={stateInfo(trip.state).color} value={(trip.deliveries_ended/trip.deliveries_total)*100}/> */}
                            </Div>
                            <Div sx={{minWidth: 35}}>
                                {/* <Typography variant="body2" color="text.secondary">{`${trip.deliveries_ended}/${trip.deliveries_total}`}</Typography> */}
                            </Div>
                        </Div>
                    </Grid>

                    {/* Con muchos productos la tarjeta crecia sin limite: la lista tiene un alto
                        maximo (unos 6 productos) y el resto se ve con scroll dentro de la tarjeta. */}
                    <Grid item xs={12} md={6} sx={{ mt: 4 }}>
                        <Div sx={{ maxHeight: 280, overflowY: 'auto', pr: 1 }}>
                            {renderOrderDetails(o)}
                        </Div>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        {renderStats(o)}
                        {/* <IconButton edge="end" onClick={() => onTripFocus(trip)}>
                            <MapOutlinedIcon color={ _.get(trip, 'deliveries[0].has_route') == true ? 'success' : 'disabled' }/>
                        </IconButton>
                        <IconButton edge="end" onClick={() => onDriverEdit(trip)}>
                            { (trip?.driver?.phone_primary || trip?.driver?.phone_seondary) ?
                                <PhoneIphoneOutlinedIcon color='success'/>
                            :
                                <PhonelinkEraseOutlinedIcon color='error'/>
                            }
                        </IconButton>
                        <ImagesDownloadBtn fieldIdentifiers="trip.deliveries.delivery_details.images" resourceIds={trip.id} disabled={_.sumBy(trip.deliveries, (d) => { return (d.docs_images_count + d.images_count) }) <= 0} />
                        <IconButton edge="end" onClick={() => onViewMore(trip)}>
                            {viewMoreActive ? <UnfoldLessOutlinedIcon /> : <UnfoldMoreOutlinedIcon />}
                        </IconButton> */}
                    </Grid>

                    {/* El comentario va a lo ancho al pie: en la columna izquierda era angosto,
                        se hacia muy alto y empujaba la tarjeta. */}
                    {o.comment && (
                        <Grid item xs={12} sx={{ pt: '8px !important' }}>
                            <Alert
                                severity="info"
                                icon={<CommentOutlinedIcon fontSize="small" />}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    px: 1,
                                    py: 0.5,
                                    wordBreak: 'break-word',
                                }}
                            >
                                {o.comment}
                            </Alert>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );

    const toggleOrderExpanded = (orderId) => {
        setExpandedOrderIds(prev =>
            prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
        );
    };

    const allOrdersExpanded = orders?.length > 0 && orders.every(o => expandedOrderIds.includes(o.id));

    // Una pagina sin ningun pedido con acciones no muestra la columna: quedaria vacia.
    const showActionsColumn = (orders || []).some(tieneAcciones);
    const ORDER_TABLE_COLUMNS = showActionsColumn ? 9 : 8;

    // Columna Nº Pedido: el logo del origen antes del numero, y despues como sale el pedido
    // (Flex, retiro...) y su documento, antes de las acciones. El logo va en un espacio de
    // ancho fijo para que los numeros queden alineados aunque el pedido no tenga logo.
    const renderOrderCodeCell = (o) => {
        const slots = orderHeaderSlots(o);
        return (
            <Div sx={{
                display: 'flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap',
                '& > *, & > div > *': { marginLeft: '0 !important' },
            }}>
                <Div sx={{ width: ORIGIN_LOGO_WIDTH, flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
                    {slots.meli ? (
                        <img src="/images/icons/mercado-libre-color.svg" alt="Mercado Libre" style={{ width: 20, height: 28 }} />
                    ) : (
                        <OrderSourceBadges order={o} only="logo" />
                    )}
                </Div>
                <Typography variant="h4" sx={{ mb: 0, fontSize: '1rem', fontVariantNumeric: 'tabular-nums' }}>
                    {o.code}
                </Typography>
                {slots.pickup && <img src="/images/icons/meli-pickup.svg" alt="Retiro" style={{ height: 20 }} />}
                {slots.meli && meliShippingIcon(o)}
                <OrderSourceBadges order={o} only="label" />
                {retailChip(o)}
                {agreedShippingChip(o)}
            </Div>
        );
    };

    // Fila de titulos de la tabla. Con `widths` (la copia que se pega arriba) cada celda toma
    // el ancho medido de la columna real, para que calcen con las filas de abajo.
    const renderOrdersHeaderRow = (widths = null) => {
        const cells = [
            { key: 'code', label: 'Nº Pedido', sx: { whiteSpace: 'nowrap', pl: `${ORIGIN_LOGO_WIDTH + 16}px !important` } },
            ...(showActionsColumn ? [{ key: 'actions', label: 'Acciones' }] : []),
            { key: 'date', label: 'Fecha' },
            { key: 'centre', label: 'Bodega' },
            { key: 'customer', label: 'Cliente' },
            { key: 'seller', label: 'Vendedor' },
            { key: 'products', label: 'Productos', align: 'center' },
            { key: 'state', label: 'Estado' },
            { key: 'delete', sx: { width: 40 } },
            ...(sendToPrepOpen ? [{ key: 'send', label: 'Enviar', align: 'center', padding: 'checkbox', sx: { ...sendToPrepCellSx, zIndex: 3 } }] : []),
        ];
        return (
            <TableRow>
                {cells.map((c, i) => (
                    <TableCell
                        key={c.key}
                        align={c.align}
                        padding={c.padding}
                        sx={{ ...c.sx, ...(widths && { width: widths[i], boxSizing: 'border-box', whiteSpace: 'nowrap', overflow: 'hidden' }) }}
                    >
                        {c.label}
                    </TableCell>
                ))}
            </TableRow>
        );
    };

    const renderOrdersList = () => {
        if (!orders || orders.length === 0) {
            return (
                <Typography>
                    No se encontraron datos
                </Typography>
            )
        }

        return (
            <React.Fragment>
                {/* Copia de los titulos que se pega bajo los filtros al bajar por la lista. La
                    tabla scrollea de lado por dentro, y dentro de ese scroll un sticky no se
                    pega a la pagina: por eso va afuera, con los anchos medidos de la tabla y
                    siguiendo su scroll horizontal. */}
                {stickyHead.show && !allOrdersExpanded && (
                    <Div sx={{ position: 'sticky', top: APP_HEADER_HEIGHT + filtersHeight, height: 0, zIndex: 10 }}>
                        <Div
                            ref={stickyHeadRef}
                            sx={{ overflow: 'hidden', backgroundColor: 'background.paper', borderRadius: 1, boxShadow: 2 }}
                        >
                            <Table size="small" sx={{ '& td, & th': { px: 1 }, tableLayout: 'fixed', width: stickyHead.tableWidth }}>
                                <TableHead>{renderOrdersHeaderRow(stickyHead.widths)}</TableHead>
                            </Table>
                        </Div>
                    </Div>
                )}
                <TableContainer
                    component={Card}
                    ref={tableContainerRef}
                    onScroll={(e) => { if (stickyHeadRef.current) stickyHeadRef.current.scrollLeft = e.currentTarget.scrollLeft; }}
                >
                    <Table size="small" sx={{ '& td, & th': { px: 1 } }}>
                        {/* Con todo desplegado cada pedido es su tarjeta y los titulos no le
                            corresponden a nada: se ocultan hasta que se vuelva a plegar. */}
                        <TableHead sx={allOrdersExpanded ? { display: 'none' } : undefined}>
                            {renderOrdersHeaderRow()}
                        </TableHead>
                        <TableBody>
                            {_.map(orders, (o) => {
                                const expanded = expandedOrderIds.includes(o.id);

                                if (expanded) {
                                    return (
                                        <TableRow key={o.id}>
                                            <TableCell colSpan={ORDER_TABLE_COLUMNS} sx={{ p: 1 }}>
                                                {renderOrderCard(o)}
                                            </TableCell>
                                            {sendToPrepOpen && (
                                                <TableCell padding="checkbox" align="center" sx={{ ...sendToPrepCellSx, verticalAlign: 'top', pt: 2 }}>
                                                    {renderSendToPrepCheckbox(o)}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                }

                                return (
                                    <TableRow
                                        key={o.id}
                                        hover
                                        className='order-card'
                                        onDragOver={canAssignPreparer ? handleDragOver : undefined}
                                        onDragLeave={canAssignPreparer ? handleDragLeave : undefined}
                                        onDrop={canAssignPreparer ? (e) => handleDrop(e, o.id) : undefined}
                                        // Los botones de la fila (sincronizar, imprimir, retira...) no despliegan:
                                        // varios no cortan la propagacion del clic.
                                        onClick={(e) => {
                                            if (e.target.closest('button, a, input, [role="button"]')) return;
                                            toggleOrderExpanded(o.id);
                                        }}
                                        sx={{ cursor: 'pointer' }}
                                    >
                                        <TableCell>{renderOrderCodeCell(o)}</TableCell>
                                        {showActionsColumn && (
                                            <TableCell>
                                                <Div sx={{ '& > div': { mb: 0 } }}>
                                                    {renderOrderHeader(o, { inTable: true, part: 'actions' })}
                                                </Div>
                                            </TableCell>
                                        )}
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                            {moment(o.ship_date).utc().format('DD MMM')}
                                            {erpDeliveryInfo(o) && (
                                                <Tooltip title={erpDeliveryInfo(o).titulo} arrow>
                                                    <Typography variant="caption" display="block" color={erpDeliveryInfo(o).color}>
                                                        {erpDeliveryInfo(o).texto}
                                                    </Typography>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title={o.centre?.name || ''} arrow>
                                                <span>{o.centre?.code}</span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            {/* El tope va en el texto y no en la celda: la tabla no respeta el
                                                maxWidth de una celda y la columna crecia igual. */}
                                            <Tooltip title={o.locatable?.name || ''} arrow>
                                                <Typography variant="body1" noWrap sx={{ maxWidth: 190 }}>{o.locatable?.name}</Typography>
                                            </Tooltip>
                                        </TableCell>
                                        {/* Comentario y Retira van en lugares fijos despues del vendedor:
                                            si un pedido no tiene comentario, el auto no se corre. */}
                                        <TableCell>
                                            <Div sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <Tooltip title={sellerFullName(o.seller)} arrow>
                                                    <Typography variant="body1" noWrap sx={{ width: pageHasSellers ? 104 : 0 }}>
                                                        {sellerShortName(o.seller)}
                                                    </Typography>
                                                </Tooltip>
                                                <Div sx={{ width: 24, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
                                                    {o.comment && (
                                                        <Tooltip title={o.comment} arrow>
                                                            <CommentOutlinedIcon fontSize="small" color="info" sx={{ display: 'block' }} />
                                                        </Tooltip>
                                                    )}
                                                </Div>
                                                <Div sx={{ width: 24, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
                                                    {/* Mismo criterio que la tarjeta: solo en retiros, o si ya tiene quien retira. */}
                                                    {o.state !== 'finished' && (isPickupOrder(o) || o.pickup?.name) && (
                                                        <Tooltip title={o.pickup?.name ? `Retira: ${o.pickup.name}` : 'Retira'} arrow>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => setPickupModalOrder(o)}
                                                                sx={{ p: 0.25 }}
                                                            >
                                                                <DirectionsCarFilledTwoToneIcon
                                                                    fontSize="small"
                                                                    color={o.pickup?.name ? 'success' : 'action'}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Div>
                                            </Div>
                                        </TableCell>
                                        <TableCell align="center">{o.order_details?.length || 0}</TableCell>
                                        <TableCell>
                                            <Div sx={{ display: 'flex', alignItems: 'center' }}>
                                                {/* En un pedido eliminado el rotulo del estado dice quien lo elimino y cuando. */}
                                                {canChangeOrderState && o.state !== 'deleted' ? (
                                                    <ManualOrderStateBadge order={o} onChanged={applyManualOrderState} />
                                                ) : (
                                                <Tooltip
                                                    arrow
                                                    title={o.state === 'deleted'
                                                        ? `Eliminado por ${o.deleted_by_name || 'un usuario que ya no existe'}${o.deleted_at ? ` el ${moment(o.deleted_at).format('LLL')}` : ''}`
                                                        : ''}>
                                                    <Div>
                                                        <StateBadge state={o.state} stateName={o.state_name} withIcon={true}/>
                                                    </Div>
                                                </Tooltip>
                                                )}
                                            </Div>
                                        </TableCell>
                                        <TableCell>
                                            {canDeleteOrder && o.deletable && (
                                                <Tooltip title="Eliminar pedido" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => { e.stopPropagation(); setOrderToDelete(o); }}
                                                        sx={{ color: 'text.disabled', '&:hover': { color: 'error.main' } }}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                        {sendToPrepOpen && (
                                            <TableCell padding="checkbox" align="center" sx={sendToPrepCellSx}>
                                                {renderSendToPrepCheckbox(o)}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </React.Fragment>
        )
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';

        // `dragover` se dispara varias veces por segundo mientras el puntero no
        // se mueve: si la clase ya esta puesta no se vuelve a tocar, para no
        // reiniciar la transicion del resaltado en cada evento.
        if (!e.currentTarget.classList.contains('drag-over')) {
            e.currentTarget.classList.add('drag-over');
        }
    }

    function handleDragLeave(e) {
        // `dragleave` burbujea desde los hijos de la tarjeta, asi que al pasar
        // el preparador por encima del contenido llegaba un leave por cada hijo
        // y la tarjeta se prendia y apagaba sin parar. Solo cuenta como salida
        // si el puntero se fue de la tarjeta completa; al salir de la ventana
        // relatedTarget viene null y `contains` da false, que es lo correcto.
        if (e.currentTarget.contains(e.relatedTarget)) return;

        e.currentTarget.classList.remove('drag-over');
    }

    const renderOrderDetails = (order) => {
        if(order?.order_details) {
            return (
                <List
                    dense={true}
                    // style={{maxHeight: viewMoreActive ? '500px' : '160px', overflow: 'auto', transitionDuration: '0.3s'}}
                    sx={{ padding: 0 }}>
                    {_.map(order.order_details, (d) => {
                        return (
                            <ListItem
                                key={d.id}
                                alignItems="flex-start"
                                id={d.id}>
                                    
                                <ListItemText id={d.id} 
                                    primary={
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            spacing={1}
                                            sx={{ maxWidth: 500 }}>
                                            <Typography>{d.product}</Typography>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={0.5}
                                                    sx={{
                                                        flexShrink: 0,
                                                        whiteSpace: 'nowrap',
                                                        minWidth: 120,
                                                        justifyContent: 'flex-end',
                                                    }}
                                                >
                                                {
                                                    _.some(d.delivery_details, dd => dd.picked_source === "manual")
                                                        ? (
                                                            <img
                                                                src="/images/icons/scanner-gun-thin-shake.svg"
                                                                alt="Scanner Manual"
                                                                style={{
                                                                    width: 18,
                                                                    height: 18,
                                                                    marginRight: 4,
                                                                    filter: "invert(21%) sepia(98%) saturate(7496%) hue-rotate(356deg) brightness(96%) contrast(107%)"
                                                                }}
                                                            />
                                                        )
                                                        : (
                                                            <Inventory2TwoToneIcon fontSize="small" color="primary" />
                                                        )
                                                }
                                                <Tooltip title="Cantidad original / Cantidad preparada / Cantidad pickeada / Cantidad entregada" arrow>
                                                    <Typography variant="overline" style={{ lineHeight: 1, cursor: 'default '}}>
                                                        { d.qty?.toLocaleString('es-CL')
                                                        }/{ _.sumBy(d.delivery_details, 'prepared_qty')?.toLocaleString('es-CL')
                                                        }/{ _.sumBy(d.delivery_details, 'picked_qty')?.toLocaleString('es-CL')
                                                        }/{ _.sumBy(d.delivery_details, 'delivered_qty')?.toLocaleString('es-CL')
                                                        }
                                                    </Typography>
                                                </Tooltip>
                                            </Stack>
                                        </Stack>
                                    }
                                />
                            </ListItem>
                        )
                    })}
                </List>
            )
        }
    }

    const renderStats = (order) => {
        if(order?.stats) {
            return (
                <React.Fragment>
                    {order.stats?.deliveries?.length > 0 ?
                        <React.Fragment>
                            <Typography variant="h6" sx={{mt: 1, mb: 0}}>Entregas ({order.stats?.deliveries?.length}):</Typography>
                            <Timeline sx={{
                                mt: 0,
                                [`& .${timelineItemClasses.root}:before`]: {
                                    flex: 0,
                                    padding: 0,
                                },
                            }}>
                                {
                                    order?.stats?.deliveries.map((d, i) => (
                                        <TimelineItem  key={d.id || i} >
                                            {/* <TimelineOppositeContent>
                                                {moment(d.ship_date).utc().format('DD MMM')}
                                            </TimelineOppositeContent> */}
                                            <TimelineSeparator>
                                                <TimelineDot>
                                                    <LocalShippingTwoToneIcon />
                                                </TimelineDot>
                                                { i < order?.stats?.deliveries.length - 1 && <TimelineConnector />}
                                            </TimelineSeparator>
                                            <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <StateBadge state={d.state} stateName={d.state_name} withIcon={false}/>
                                                </Stack>
                                                <Typography variant='body2' fontSize={13}>
                                                    {_.includes(['planned', 'pending', 'in_progress'], d.state) ?
                                                        <React.Fragment>
                                                            {moment(d.ship_date).utc().format('DD MMM')} {_.sumBy(d.delivery_details, 'qty')?.toLocaleString('es-CL')} items por despachar
                                                        </React.Fragment>
                                                    :
                                                        <React.Fragment>
                                                            {moment(d.ship_date).utc().format('DD MMM')} {_.sumBy(d.delivery_details, 'delivered_qty')?.toLocaleString('es-CL')} items entregados
                                                        </React.Fragment>
                                                    }
                                                </Typography>
                                            </TimelineContent>
                                        </TimelineItem>
                                    ))
                                }
                            </Timeline>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Div sx={{ mt: 4 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Sin entregas
                                </Typography>
                            </Div>
                        </React.Fragment>
                    }
                </React.Fragment>
            )
        }
    }

    const handleCreateOrder = async () => {
        try {
            const orderData = {
                customer_id: newOrder.customerId,
                centre_id: newOrder.centreId,
                seller_id: newOrder.sellerId || null,
                ship_date: newOrder.creationDate,
            };

            const orderDetailsData = newOrder.products.map((product) => {
            const qty = parseFloat(product.quantity);
            const netPrice = 1000;
                return {
                    product: product.name,
                    product_code: product.code || null,
                    qty: qty,
                    pending_qty: qty,
                    meassure_unit: product.unit || 'unid',
                    net_price: netPrice,
                    tax: Math.round(netPrice * 0.19),
                };
            });

            await orderServices.createOrder(orderData, orderDetailsData);

            setShowCreateModal(false);
            setNewOrder({ customerName: '', creationDate: moment().format('YYYY-MM-DD'), products: [] });
            setNewProduct({ code: null, name: '', unit: null, quantity: '' });
            setDocumentTypesVersion((v) => v + 1);
            setListLoading(true);
        } catch (error) {
            console.error("Error creating order:", error);
        }
    };

    const handleDragStart = (e, preparerId, preparerName) => {
        e.dataTransfer.setData("application/json", JSON.stringify({ id: preparerId, name: preparerName }));
        e.target.classList.add('dragging');
        e.dataTransfer.effectAllowed = 'move';  
    }

    function handleDragEnd(e) {
        e.target.classList.remove('dragging');
    }

    const preparersElement = (preparers) => {
        return (
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h4" color="text.secondary">
                            Preparadores:
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Arrastra un preparador y suéltalo sobre un pedido para asignarlo.
                        </Typography>
                        {preparers.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">
                                No hay preparadores disponibles.
                            </Typography>
                        ) : (
                            preparers.map(preparer => (
                                // Aquí debiera mandar el id y full_name creo
                                <Card
                                    key={ preparer.id }
                                    className='preparer-card'
                                    draggable
                                    onDragStart={ (e) => handleDragStart(e, preparer.id, preparer.full_name) }
                                    onDragEnd={ (e) => handleDragEnd(e) } >
                                    <CardContent>{ preparer.full_name }</CardContent>
                                </Card>
                            ))
                        )}
                    </Stack>
                </CardContent>
            </Card>
        )
    }

    return (
        <Grid container spacing={2}>
            {/* Titulo y filtros quedan fijos bajo la barra de la app (80px) al bajar por la lista. */}
            <Grid
                item
                xs={12}
                ref={filtersRef}
                sx={{ position: 'sticky', top: APP_HEADER_HEIGHT, zIndex: 11, backgroundColor: 'background.default' }}
            >
                {renderFilters()}
            </Grid>

            {listLoading && (
                <Grid item xs={12} style={{ textAlign: 'center', my: 5 }}>
                    <CircularProgress color="warning" />
                </Grid>
            )}

            <Grid item xs={12} md={ sidePanelOpen ? 7.5 : (canAssignPreparer ? 11.5 : 12) }>
                <Div id="order-list">
                    {renderOrdersList()}
                </Div>
                {/* En la columna de la tabla y no a todo el ancho: con el panel lateral abierto
                    quedaba corrida hacia el panel en vez de centrada bajo la tabla. */}
                <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageSelect={(page) => { setCurrentPage(page); setListLoading(true) }} />
            </Grid>

            <Grid
                item
                xs={0}
                md={0.5}
                sx={{
                    position: 'sticky',
                    top: APP_HEADER_HEIGHT + filtersHeight + 24,
                    alignSelf: 'flex-start',
                    display: canAssignPreparer ? 'flex' : 'none',
                    justifyContent: 'center',
                    zIndex: 10,
                }}
            >
                <IconButton
                    size="small"
                    onClick={() => setShowPreparers(prev => !prev)}
                    sx={{
                        backgroundColor: 'white',
                        border: '1px solid #e0e0e0',
                        boxShadow: 2,
                        width: 32,
                        height: 32,
                        '&:hover': {
                            backgroundColor: '#f5f5f5',
                        },
                    }}
                >
                    {showPreparers ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </Grid>

            <Grid
                ref={sidePanelRef}
                item
                xs={12}
                md={4}
                sx={{
                    position: 'sticky',
                    // Debajo de la cabecera fija de la pagina, que si no lo tapa.
                    top: APP_HEADER_HEIGHT + filtersHeight,
                    height: 'fit-content',
                    // Sticky y mas alto que la pantalla deja preparadores fuera de alcance:
                    // el panel scrollea por dentro.
                    maxHeight: `calc(100vh - ${APP_HEADER_HEIGHT + filtersHeight + pageBottomGap}px)`,
                    overflowY: 'auto',
                    // El scroll corta lo que sale de su borde: sin margen a la derecha y abajo,
                    // la sombra de las tarjetas quedaba cortada y la de Preparadores parecia trunca.
                    pr: 1.5,
                    pb: 2,
                    // Al llegar al final del panel no se pone a scrollear la pagina de atras.
                    overscrollBehavior: 'contain',
                    transition: 'all 0.3s ease',
                    display: sidePanelOpen ? 'block' : 'none',
                }}
            >
                {agreedPanelOrder && (
                    <AgreedShippingPanel
                        order={agreedPanelOrder}
                        carriers={companySettings?.available_dropoff_carriers}
                        onClose={closeAgreedPanel}
                        onSave={(payload) => handleSaveAgreedShipping(agreedPanelOrder, payload)}
                        saving={agreedSaving}
                    />
                )}
                {sendToPrepOpen && (
                    <SendToPreparationPanel
                        selected={sendToPrepSelected}
                        onRemove={(id) => setSendToPrepSelection((prev) => { const next = { ...prev }; delete next[id]; return next; })}
                        onClear={() => setSendToPrepSelection({})}
                        onClose={closeSendToPrep}
                        onSent={() => { setSendToPrepSelection({}); setListLoading(true); }}
                    />
                )}
                {printCart.length > 0 && (
                    <Card sx={{ mb: 2, p: 2 }}>
                        <Div sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                <LocalPrintshopTwoToneIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                Etiquetas ML ({printCart.length})
                            </Typography>
                            <IconButton size="small" onClick={() => setPrintCart([])}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Div>
                        {printCart.map(o => (
                            <Div key={o.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>
                                    #{o.code}
                                </Typography>
                                <IconButton size="small" onClick={() => togglePrintCart(o)}>
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            </Div>
                        ))}
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ mt: 1 }}
                            startIcon={<LocalPrintshopTwoToneIcon />}
                            onClick={handlePrintLabels}
                            disabled={printLoading}
                        >
                            {printLoading ? 'Generando...' : 'Imprimir etiquetas (PDF)'}
                        </Button>
                        <Button
                            variant="outlined"
                            fullWidth
                            sx={{ mt: 1 }}
                            startIcon={<PrintOutlinedIcon />}
                            onClick={() => setZebraDialogOpen(true)}
                            disabled={zebraLoading}
                        >
                            {zebraLoading ? 'Enviando...' : 'Imprimir en Zebra'}
                        </Button>
                    </Card>
                )}
                {bxPrintCart.length > 0 && (
                    <Card sx={{ mb: 2, p: 2 }}>
                        <Div sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                <LocalPrintshopTwoToneIcon sx={{ verticalAlign: 'middle', mr: 0.5, color: '#0052cc' }} />
                                Etiquetas BlueExpress ({bxPrintCart.length})
                            </Typography>
                            <IconButton size="small" onClick={() => setBxPrintCart([])}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Div>
                        {bxPrintCart.map(o => (
                            <Div key={o.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>
                                    #{o.code}
                                </Typography>
                                <IconButton size="small" onClick={() => toggleBxPrintCart(o)}>
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            </Div>
                        ))}
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ mt: 1, backgroundColor: '#0052cc', '&:hover': { backgroundColor: '#003d99' } }}
                            startIcon={<LocalPrintshopTwoToneIcon />}
                            onClick={handleBluexpressPrint}
                            disabled={bxPrintLoading}
                        >
                            {bxPrintLoading ? 'Generando...' : 'Imprimir etiquetas BX (PDF)'}
                        </Button>
                    </Card>
                )}
                <ZebraPrintDialog
                    isOpen={zebraDialogOpen}
                    onClose={() => setZebraDialogOpen(false)}
                    onConfirm={handleZebraPrint}
                    loading={zebraLoading}
                />
                <HaulersLabelDialog
                    isOpen={!!haulersLabelOrder}
                    order={haulersLabelOrder}
                    onClose={() => setHaulersLabelOrder(null)}
                />
                {preparersElement(preparers)}
            </Grid>

            {/* Los modales no van en un Grid item: cada uno vacio sumaba su margen bajo la pagina. */}

            <>
                <FileUploaderModal
                    kind='default_bulk_order_import'
                    open={showFileUploaderModal}
                    fileUploaderOptions={{
                        errorMsg: importError,
                        onFileSelection: (acceptedFiles) => {
                            setFilesToImport(acceptedFiles)
                        }
                    }}
                    onClose={() => { setShowFileUploaderModal(false) }}
                    onSave={importOrders}
                    saving={importing}
                    canSave={filesToImport.length > 0}
                />
            </>

            <>
                <CreateOrderModal
                    open={showCreateModal}
                    onClose={() => setShowCreateModal(false)}
                    onSubmit={handleCreateOrder}
                    newOrder={newOrder}
                    setNewOrder={setNewOrder}
                    newProduct={newProduct}
                    setNewProduct={setNewProduct}
                />
            </>

            <>
                <Dialog fullWidth maxWidth="md" open={Boolean(packagePhotosOrder)} onClose={() => setPackagePhotosOrder(null)}>
                    <DialogTitle>Fotos de bultos · Pedido {packagePhotosOrder?.code}</DialogTitle>
                    <DialogContent>
                        {packagePhotosOrder &&
                            <PackagePhotos
                                key={packagePhotosOrder.id}
                                load={() => orderServices.getPackagePhotos(packagePhotosOrder.id)}
                                emptyText="Este pedido no tiene fotos de bultos." />
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setPackagePhotosOrder(null)}>Cerrar</Button>
                    </DialogActions>
                </Dialog>

                <PickupPersonModal
                    open={Boolean(pickupModalOrder)}
                    initialData={pickupModalOrder?.pickup}
                    saving={pickupSaving}
                    onClose={() => setPickupModalOrder(null)}
                    onSave={(pickup) => handleSavePickup(pickupModalOrder, pickup)}
                    onRemove={() => handleRemovePickup(pickupModalOrder)}
                />

                <ConfirmDialog
                    open={Boolean(orderToDelete)}
                    title="Eliminar pedido"
                    message={
                        <>
                            ¿Estás seguro que deseas eliminar el pedido <strong>{orderToDelete?.code}</strong>?
                            <br />
                            Al eliminarlo no podrá volver a planificarse, sus entregas en viaje se
                            cancelan y queda almacenado el registro de quién lo eliminó.
                        </>
                    }
                    loading={deletingOrder}
                    onClose={() => setOrderToDelete(null)}
                    onConfirm={handleDeleteOrder}
                />
            </>
        </Grid>
    );
};

export default OrdersList;
